import httpClient from '../httpClient';

export async function getAllFaqs() {
  try {
    const response = await httpClient.get(`/api/faq`);
    console.log(response.data);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de FAQ: ' + error);
  }
}

export async function getFaq(faqId: string) {
  try {
    const response = await httpClient.get(`/api/faq/${faqId}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter FAQ: ' + error);
  }
}
